<template>
  <div
    v-for="filterType in filterData"
    :id="`${filterType.slugUrl}-container`"
    :key="filterType.id"
    class="type-filter-container flex-column-layout"
  >
    <UiDivider :type="'primary'" />
    <AccordionCard :title="filterType.name">
      <div class="swa-checkbox-container">
        <UiCheckbox
          v-for="(filterValue, index) in filterType.filterValues"
          :id="filterValue.id"
          :key="filterValue.id"
          :model-value="selectedFilterParams.types[filterType.slugUrl]"
          class="checkbox-option"
          :native-value="filterValue.slugUrl"
          :label="filterValue.value"
          @update:model-value="
            onFilterUpdate($event, filterValue, index, filterType)
          "
        />
      </div>
    </AccordionCard>
  </div>
</template>

<script lang="ts" setup>
import UiCheckbox from '@sephora-asia/ui-checkbox'
import UiDivider from '@sephora-asia/ui-divider'
import AccordionCard from './accordion-card.vue'
import type {
  FilterValues,
  TypeFilters,
} from '~/types/api/data/product/filter/filter.types'
import useFilterTrackingEvent from '~/composables/utils/product-listing/filter/use-product-listing-filter-tracking'

defineProps<{
  filterData: TypeFilters[]
}>()

const { selectedFilterParams } = useProductListingFiltersStore()
const { trackFilterClicked } = useFilterTrackingEvent()

function onFilterUpdate(
  event: string[],
  typeFilter: FilterValues,
  index: number,
  filterType: TypeFilters
) {
  trackFilterClicked(event, {
    value: typeFilter.slugUrl,
    slugUrl: typeFilter.slugUrl,
    filterIndex: index,
    filterCategoryIndex: 1,
    type: filterType.slugUrl,
  })
}
</script>
